<template>
  <td>
    <slot />
  </td>
</template>

<script>
export default {
  name: 'GridColumn',
  props: {
    title: String,
    customKey: [String, Number],
    field: String,
    meta: [String, Number, Boolean, Function, Object, Array],
    width: [Number, String],
    numeric: Boolean,
    centered: Boolean,
    searchable: Boolean,
    sortable: Boolean,
    visible: {
      type: Boolean,
      default: true,
    },
    customSort: Function,
    internal: Boolean, // Used internally by Table
  },
  data() {
    return {
      newKey: this.customKey || this.title,
    };
  },
  computed: {
    rootClasses() {
      return {
        'has-text-right': this.numeric && !this.centered,
        'has-text-centered': this.centered,
      };
    },
  },
  mounted() {
    this.addRefToTable();
  },
  methods: {
    addRefToTable() {
      const repeated = this.$parent.internalColumns.some((x) => x.newKey === this.newKey);
      if (!repeated) {
        this.$parent.internalColumns.push(this);
      }
    },
  },
};
</script>
